module.exports = {
    form: {
        fields: {
            location: {
                missingUrl: 'Bitte befülle erst eines der angegebenen Felder.',
            },
        },
    },
    addUser: {
        codeAlreadyInUse: 'Dieser Benutzername ist bereits vergeben!',
    },
    employees: {
        sms_provider_not_granted: 'Der SMS-Versand ist im Moment deaktiviert. Bestätigungs-SMS wurde daher keine vesandt.',
        export: {
            employeeReports: {
                missingMonthStartTS: 'Ohne die Angabe eines Monats kann der Export nicht starten.',
                futureMonthStartTS: 'Die Daten für die Stundenlisten können nicht bereit sein wenn der Export-Zeitraum in der Zukunft liegt.',
                noAvailableEmployeesFound: 'Es wurden keine für den Stundenlisten-Export geeigneten Mitarbeiter gefunden.<br><br>Die Mitarbeiter müssen einen <b>Namen</b> haben, <b>aktiv</b> sein, <b>intern</b> sein, als <b>Crew</b> einsetzbar sein und eine <b>Soll-Arbeitszeit</b> hinterlegt haben.',
                employeeNotSuitable: 'Der aktuelle Mitarbeiter ist nicht bereit für den Stundenlisten-Export.<br><br>Damit der Export funktionieren kann muss der Mitarbeiter einen <b>Namen</b> haben, <b>aktiv</b> sein, <b>intern</b> sein, als <b>Crew</b> einsetzbar sein und eine <b>Soll-Arbeitszeit</b> hinterlegt haben.',
                fileDownloadError: 'Beim Exportieren der Stundenliste ist ein Fehler aufgetreten.',
                multiFileDownloadError: 'Beim Exportieren der Stundenlisten sind Fehler aufgetreten:<br><br>Von ursprünglich {{nrOfEntries}} Downloads waren<br>{{nrOfSuccesses}} erfolgreich und<br>{{nrOfErrors}} nicht erfolgreich.',
            },
        },
    },
    employeeReports: {
        export: {
            employeeReports: {
                noAvailableEmployeesFound: 'Es wurden keine Stundenlisten mit den angegebenen Parametern gefunden.',
                fileDownloadError: 'Beim Exportieren der Stundenliste ist ein Fehler aufgetreten.',
                multiFileDownloadError: 'Beim Exportieren der Stundenlisten sind Fehler aufgetreten:<br><br>Von ursprünglich {{nrOfEntries}} Downloads waren<br>{{nrOfSuccesses}} erfolgreich und<br>{{nrOfErrors}} nicht erfolgreich.',
            },
        },
    },
    shippingOrder: {
        notAbleToReplaceShippingOrder: 'Lieferscheine die bereits abgerechnet oder ersetzt wurden können nicht mehr verändert oder ersetzt werden.',
    },
    projects: {
        projectTerms: {
            notAbleToMoveProjectTermsToAnotherProjectInCaseOfShippingOrderPresence: 'Die folgenden gewählten Termine können nicht verschoben werden, da sie bereits auf einem Lieferschein eingetragen wurden: {{projectTermIDs}}!',
            notAbleToMoveNoProjectTermsToAnotherProject: 'Bitte wähle die Termine, die Du in ein anderes Projekt verschieben möchten.',
            notAbleToMoveProjectTermsToTheVerySameProject: 'Die gewählten Termine sind bereits in diesem Projekt. Bitte wähle ein Anderes.',
            notAbleToAddNewTermsAnyLonger: 'Der Zustand des aktuellen Projekts lässt diese Operation nicht mehr zu.',
        },
        projectTermJobs: {
            notAbleToAssignEmployeeViaApplicationStatusRevoked: 'Ein Bewerber kann nur zugewiesen werden wenn die Ausschreibung nicht abgelehnt wurde.',
        },
        customer: {
            requestOffer: {
                customerContactConfirmationIsMandatory: {
                    message: 'Der Kunden-Datensatz zu deiner Person muss von unserem Team bestätigt werden, bevor Du ein Angebot anfordern kannst.',
                },
                missingUrl: {
                    message: 'Beim Erstellen des Angebots ist ein Fehler aufgetreten.',
                },
            },
        },
    },
    customers: {
        customerContacts: {
            notAbleToMoveCustomerContactToTheVerySameCustomer: 'Der gewählte Auftraggeber ist bereits diesem Kunden zugewiesen. Bitte wähle einen Anderen.',
        },
    },
    insertPrice: {
        unique_valid_jobID: 'Für diesen Job und Zeitraum ist bereits ein Preis angelegt worden.',
        unique_valid_jobID_employeeID: 'Für diesen Job und Zeitraum ist bereits ein Preis angelegt worden.',
    },
    prices: {
        priceManagementWithoutPriceConfigImpossible: 'Beim Laden der zugehörigen Preiskonfiguration für den betroffenen Zeitraum ist ein Fehler aufgetreten.',
        priceTiles: {
            cannotEditPriceWithoutID: {
                message: 'Beim Öffnen des Preisformulars ist ein Fehler aufgetreten.',
            },
            cannotEditPriceWithoutData: {
                message: 'Beim Öffnen des Preisformulars ist ein Fehler aufgetreten.',
            },
            cannotEditPriceWithoutJob: {
                message: 'Beim Öffnen des Preisformulars ist ein Fehler aufgetreten.',
            },
            cannotEditPriceWithoutValidPeriod: {
                message: 'Beim Öffnen des Preisformulars ist ein Fehler aufgetreten.',
            },
        },
    },
    advertiseProjectTermJob: {
        alreadyDone: 'Dieser Job wurde bereits ausgeschrieben.',
    },
    clientError: {
        'check-customer-project-changes-error-6': {
            title:    '',
            subTitle: 'Projekt',
            message:  '',
        },
    },
    500: {
        'internal-server-error': {
            title:    'Fehler',
            subTitle: 'Unerwartet',
            message:  'Leider ist ein unerwarteter Fehler aufgetreten.',
        },
        'update-cost-center-invoice-completed-already': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Bei bereits abgeschlossenen Rechnungen können nur mehr die internen Notizen (innerhalb der Rechnung oder der Kostenstellen) bearbeitet werden.',
        },
        'update-cost-center-invoice-of-internal-project': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Interne Projekte sind von der Rechnungslegung ausgeschlossen.<br>Deshalb können nur mehr die internen Notizen (innerhalb einer Rechnung oder Kostenstelle) bearbeitet werden.',
        },
        'update-cost-center-invoice-missing': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Ohne zugehörige Rechnung kann eine Kostenstelle nicht bearbeitet werden.',
        },
        'update-cost-center-invoice-move-not-granted': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Kostenstellen können niemals einer anderen Rechnung zugeordnet werden.',
        },
        'update-invoice-missing-employee-id': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Rechnungen können nur von Benutzern manipuliert werden, die auch einem Mitarbeiter zugeordnet sind.',
        },
        'update-invoice-of-internal-project': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Interne Projekte sind von der Rechnungslegung ausgeschlossen.<br>Deshalb können nur mehr die internen Notizen (innerhalb einer Rechnung oder Kostenstelle) bearbeitet werden.',
        },
        'update-invoice-invalid-set-incomplete': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Bestätigte oder stornierte Rechnungen können nicht mehr als unvollständig markiert werden.',
        },
        'update-invoice-invalid-set-complete-and-canceled': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Wenn man eine Rechnung storniert sollte sie nicht mehr als bestätigt markiert werden. Warum sollte man eine Rechnung generieren wollen, die man dann gleich wieder gutschreiben muss?',
        },
        'update-invoice-redo-non-confirmed-non-canceled': {
            title:    '',
            subTitle: 'Rechnungen',
            message:  'Um eine Rechnung - wiederholt oder nicht - zu verarbeiten muss sie zumindest als bestätigt oder storniert markiert werden.',
        },
        'update-price-prohibited-due-to-price-valid-time-range': {
            title:    '',
            subTitle: 'Preise',
            message:  'Preise können nur bearbeitet werden, wenn der Gültigkeitszeiraum noch in der Zukunft liegt.',
        },
        'update-price-prohibited-due-to-missing-privileges': {
            title:    '',
            subTitle: 'Preise',
            message:  'Das Ändern der eigenen Preise ist externen Mitarbeitern vorbehalten.',
        },
        'check-customer-project-changes-error': {
            title:    '',
            subTitle: 'Projekt',
            message:  'Der Zustand des aktuellen Projekts lässt diese Operation nicht zu. (1)',
        },
        'check-customer-project-changes-error-2': {
            title:    '',
            subTitle: 'Projekt',
            message:  'Der Zustand des aktuellen Projekts lässt diese Operation nicht zu. (2)',
        },
        'check-customer-project-changes-error-3': {
            title:    '',
            subTitle: 'Projekt',
            message:  'Der Zustand des aktuellen Projekts lässt diese Operation nicht zu. (3)',
        },
        'check-customer-project-changes-error-4': {
            title:    '',
            subTitle: 'Projekt',
            message:  'Der Zustand des aktuellen Projekts lässt diese Operation nicht zu. (4)',
        },
        'check-customer-project-changes-error-5': {
            title:    '',
            subTitle: 'Projekt',
            message:  'Der Zustand des aktuellen Projekts lässt diese Operation nicht zu. (5)',
        },
        'set-status-by-customer-error-1': {
            title:    '',
            subTitle: 'Projekt',
            message:  'Bei der Zustandsänderung dieses Projekts ist leider ein Fehler aufgetreten.',
        },
        'set-status-by-customer-error-2': {
            title:    '',
            subTitle: 'Projekt',
            message:  'Die angestrebte Zustandsänderung ist ungültig. Ein Beispiel: Bereits fixierte Projekte können nicht mehr bestellt werden.',
        },
        'set-status-by-customer-error-3': {
            title:    '',
            subTitle: 'Projekt',
            message:  'Die Daten für Projekte, Termine und ihre Planstellen müssen gewisse Mindestanforderungen erfüllen, damit ein Projekt umsetzbar wird.<br><br>Bitte prüfe deine Angaben vor der Bestellung noch einmal auf Vollständigkeit. Halte gegebenenfalls Ausschau nach roten Markierungen um Details zu erfahren und wiederhole den Vorgang.',
        },
        'create-offer-by-customer-error-missing-privileges': {
            title:    '',
            subTitle: 'Angebot',
            message:  'Dir fehlen die nötigen Rechte um Angebote anzufordern.',
        },
        'create-offer-by-customer-error-1': {
            title:    '',
            subTitle: 'Angebot',
            message:  'Dieses Projekt hat einen Zustand erreicht, der eine Angebotslegung verunmöglicht.',
        },
        'create-offer-by-customer-error-2': {
            title:    '',
            subTitle: 'Angebot',
            message:  'Die Daten für Projekte, Termine und ihre Planstellen müssen gewisse Mindestanforderungen erfüllen, damit ein Projekt umsetzbar wird.<br><br>Bitte prüfe deine Angaben vor der Bestellung noch einmal auf Vollständigkeit. Halte gegebenenfalls Ausschau nach roten Markierungen um Details zu erfahren und wiederhole den Vorgang.',
        },
        'finalize-offer-missing-offer-id-error': {
            title:    '',
            subTitle: 'Angebot',
            message:  'Beim Erstellen des Angebots ist ein Fehler aufgetreten.',
        },
        'finalize-offer-error': {
            title:    '',
            subTitle: 'Angebot',
            message:  'Beim Erstellen des Angebots ist ein Fehler aufgetreten.',
        },
        'absence-check-error': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Beim Überprüfen deiner Angaben ist ein Fehler aufgetreten.',
        },
        'absence-time-frame-incomplete': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Bitte fülle den Zeitraum vollständig aus. (1)',
        },
        'absence-time-frame-null-invalid': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Bitte fülle den Zeitraum vollständig aus. (2)',
        },
        'crew-defined-absence-without-employee-not-possible': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Nur mit gültiger Anmeldung kann dieser Vorgang ausgeführt werden.',
        },
        'crew-defined-absence-invalid-type-combination': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Ungültige Verwendung dieses Typs.',
        },
        'crew-defined-internal-employee-absence-time-frame-past-invalid': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Diese Operation ist nur gültig wenn der angegebene Zeitraum in der Zukunft liegt.',
        },
        'crew-defined-internal-employee-absence-status-finalized': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Diese Operation ist nur für noch nicht genehmigte Datensätze gültig.',
        },
        'crew-defined-internal-employee-prev-absence-time-frame-past-invalid': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Diese Operation ist nur für zukünftige Abwesenheiten möglich.',
        },
        'office-defined-absence-manipulation-check-error': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Beim Überprüfen deiner Angaben ist ein Fehler aufgetreten.',
        },
        'office-defined-absence-manipulation-for-internal-employees-only-error': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Die Manipulation von Abwesenheitseinträgen externer Mitarbeiter ist nicht gestattet.',
        },
        'office-defined-absence-status-confirmed-manipulation-error': {
            title:    '',
            subTitle: 'Abwesenheit',
            message:  'Dir fehlen die nötigen Rechte um Abwesenheiten zu genehmigen.',
        },
    },
}